<template>
  <mm-modal
    class="aireach-activate-modal"
    title="激活前必填信息"
    width="600px"
    destroy-on-close
    :esc-closable="false"
    :mask-closable="false"
    :visible.sync="visible"
    @close="handleClose"
  >
    <div class="aireach-activate-modal-content">
      <div class="tips">
        <mm-alert
          type="warning"
          show-icon
          :closable="false"
        >
          <template #description>
            <span class="tips-content">
              请严肃填写：请在此处填写贵司网址（建议用独立站或者国际站，至少填写一项），网址用于OKKI AiReach提前分析贵司生意画像，如您站点还未正式上线请勿随意填写。如有疑问可
              <a
                class="tips-content-link"
                @click="openOnlineService"
                target="_blank"
              >咨询客服</a>
            </span>
          </template>
        </mm-alert>
      </div>
      <mm-form layout="vertical">
        <mm-form-field label="独立站网址">
          <mm-input 
            ref="homePageInput"
            v-model="formData.home_page"
            placeholder="https://"
          />
        </mm-form-field>
        <mm-form-field label="国际站店铺">
          <mm-input
            v-model="formData.site_page"
            placeholder="https://"
          />
        </mm-form-field>
        <mm-form-field>
          <div class="form-actions">
            <mm-button @click="handleClose">
              取消
            </mm-button>
            <template v-if="!isFormValid">
              <mm-tooltip
                content="公司主页至少填写一项"
              >
                <mm-button
                  type="primary"
                  disabled
                >
                  提交
                </mm-button>
              </mm-tooltip>
            </template>
            <template v-else>
              <mm-button
                type="primary"
                @click="handleSubmit"
              >
                提交
              </mm-button>
            </template>
          </div>
        </mm-form-field>
      </mm-form>
    </div>
  </mm-modal>
</template>

<script>
import { Tooltip } from 'amumu-ui'
import HomeApi from '@api/home'
import { verifyUrl } from '@utils/verify'
import qs from 'qs'
import { mapState } from 'vuex'
import mainApi from '@api/main'

export default {
  name: 'AiReachActivateModal',
  components: {
    'mm-tooltip': Tooltip,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    aiReachLinks: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        site_page: '',
        home_page: '',
      },
      planVersion: {},
    }
  },
  computed: {
    ...mapState('main', {
      userInfo: state => state.userInfo,
      isClientActive: state => state.isClientActive,
    }),
    isFormValid() {
      return this.formData.home_page || this.formData.site_page
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.formData.site_page = this.aiReachLinks.site_page || '';
        this.formData.home_page = this.aiReachLinks.home_page || '';
        
        // 弹窗打开时聚焦到独立站网址输入框
        this.$nextTick(() => {
          if (this.$refs.homePageInput) {
            this.$refs.homePageInput.focus();
          }
        });
      }
    },
  },
  created() {
    this.isClientActive && this.fetchPlanVersion()
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    async handleSubmit () {
      const { site_page, home_page } = this.formData

      if(home_page && !verifyUrl(home_page)) {
        this.$message.warning('请输入正确格式的独立站网址')
        return
      }

      if(site_page && !verifyUrl(site_page)) {
        this.$message.warning('请输入正确格式的国际站店铺网址')
        return
      }

      try {
        await HomeApi.submitAiReachLink({
          site_page,
          home_page
        })

        this.handleClose()
        this.$emit('submit-success')
      } catch (error) {
        // error
      }
    },
    fetchPlanVersion() {
      mainApi.fetchPlanVersion().then(data => {
        this.planVersion = data
      })
    },
    openOnlineService() {
      const SUPPORT_URL = 'https://support.okki.com';

      const {
        is_trial = 0,
        user_id = '',
        client_id = '',
        userId = '',
        email = '',
        family_name = '',
        second_name = '',
        user_language = 'zh-CN',
      } = this.userInfo;
      const languageMap = {
        'zh-CN': 'cn',
        'zh-TW': 'tw',
        en: 'en',
      };
      const planVersionContent = Number(is_trial)
        ? 'OKKI Lucky'
        : encodeURIComponent(
            [this.planVersion.system]
              .concat(this.planVersion.modules)
              .join('&'),
          );
      const visitUrl = encodeURIComponent(location.href);
      const zhichiConfig = {
        email,
        visitUrl,
        uname: email,
        partnerid: userId || user_id,
        locale: languageMap[user_language],
        realname: `${family_name} ${second_name}`,
        customer_fields: JSON.stringify({
          /**
           * 用户ID
           */
          customField2: userId || user_id,
          /**
           * 公司ID
           */
          customField3: client_id,
          /**
           * 版本信息
           */
          customField4: planVersionContent,
        }),
      };
      const openZhichiService = () => {
        window.open(`${SUPPORT_URL}?${qs.stringify(zhichiConfig)}`);
      };

      openZhichiService();
    }
  }
}
</script>

<style lang="scss" scoped>
.aireach-activate-modal-content {
  .tips {
    margin-bottom: 16px;
  }

  .tips-content-link {
    cursor: pointer;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>